"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightCardContent = exports.LeftCardContent = exports.CardRow = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardRow = _styledComponents.default.div.withConfig({
  displayName: "TwoColCardstyles__CardRow",
  componentId: "yd2ptt-0"
})(["display:flex;word-break:break-word;"]);

exports.CardRow = CardRow;

var LeftCardContent = _styledComponents.default.div.withConfig({
  displayName: "TwoColCardstyles__LeftCardContent",
  componentId: "yd2ptt-1"
})(["width:", ";min-width:", ";"], function (props) {
  return props.theme.cardLeftContent;
}, function (props) {
  return props.theme.cardLeftContent;
});

exports.LeftCardContent = LeftCardContent;

var RightCardContent = _styledComponents.default.div.withConfig({
  displayName: "TwoColCardstyles__RightCardContent",
  componentId: "yd2ptt-2"
})(["padding-left:", ";"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
});

exports.RightCardContent = RightCardContent;